import { render, staticRenderFns } from "./mobileGrowupBook.vue?vue&type=template&id=22ddff93&scoped=true&"
import script from "./mobileGrowupBook.vue?vue&type=script&lang=js&"
export * from "./mobileGrowupBook.vue?vue&type=script&lang=js&"
import style0 from "./mobileGrowupBook.vue?vue&type=style&index=0&id=22ddff93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ddff93",
  null
  
)

export default component.exports